import React, { FC } from 'react';
import { Text } from '@endpoint/blockparty';

export const Label: FC = ({ children }) => (
  <Text as="p" color="carbon500" size="fontSize10">
    {children}
  </Text>
);
